export { default as Highlighter } from './highlighter';
